export enum DayName {
  mon = 'monday',
  tue = 'tuesday',
  wed = 'wednesday',
  thu = 'thursday',
  fri = 'friday',
  sat = 'saturday',
  sun = 'sunday',
}
